import * as Yup from "yup";
import {TranslatedText} from "../../../helpers/helpers";
import React from "react";

export const initialValuesWatterBuilding = {
  unit_0: '',
  unit_1: '',
  unit_2: '',
  unit_3: '',
  unit_4: '',
  unit_5: '',
  unit_6: '',
  unit_7: '',
  unit_8: '',
  unit_9: '',
  unit_10: '',
  non_residential: '',
};

const getValidation = () => {return Yup.number()
  .typeError(<TranslatedText i18nKey="selfread.add.form.typeError"/>
  )}

export const schemaWatterBuilding = Yup.object().shape({
  unit_0: getValidation(),
  unit_1: getValidation(),
  unit_2: getValidation(),
  unit_3: getValidation(),
  unit_4: getValidation(),
  unit_5: getValidation(),
  unit_6: getValidation(),
  unit_7: getValidation(),
  unit_8: getValidation(),
  unit_9: getValidation(),
  unit_10: getValidation(),
  non_residential: getValidation()
});


